import { createCrossTabUserSyncPlugin, PrivyProvider } from '@privy-io/react-auth';
import { type ReactNode } from 'react';

import { config } from '@/config';
import { theme } from '@/shared/design-system';

interface SuiProviderProps {
  children: ReactNode;
}

// Privy renders its wallet screens in an iframe on its own domain, so they cannot use
// design-system components and its appearance API accepts hex strings only. The tokens are
// typed as `string` rather than the `#${string}` Privy requires, hence the cast; the values
// still come from the palette, so a token change carries through.
const asHexColor = (token: string) => token as `#${string}`;

const PRIVY_CROSS_TAB_CHANNEL_ID = 'gamma-prime-privy-user';

const privyPlugins = [createCrossTabUserSyncPlugin({ channelId: PRIVY_CROSS_TAB_CHANNEL_ID })];

export function SuiProvider({ children }: SuiProviderProps) {
  return (
    <PrivyProvider
      appId={config.privy.appId}
      clientId={config.privy.clientId}
      config={{
        loginMethods: ['passkey'],
        appearance: {
          theme: asHexColor(theme.colors.background.canvas),
          accentColor: asHexColor(theme.colors.brand.solid),
        },
        embeddedWallets: {
          ethereum: { createOnLogin: 'off' },
          solana: { createOnLogin: 'off' },
        },
        mfa: {
          noPromptOnMfaRequired: true,
        },
        plugins: privyPlugins,
      }}
    >
      {children}
    </PrivyProvider>
  );
}
